import { api } from "./_client";

export async function listQuoteTemplates() {
    const { data } = await api.get("/quote-templates");
    return data;
}

export async function createQuoteTemplate(payload) {
    const { data } = await api.post("/quote-templates", payload);
    return data;
}

export async function updateQuoteTemplate(id, payload) {
    const { data } = await api.patch(`/quote-templates/${id}`, payload);
    return data;
}

export async function deleteQuoteTemplate(id) {
    const { data } = await api.delete(`/quote-templates/${id}`);
    return data;
}

// iter-180 — Quote template version history
export async function listQuoteTemplateHistory(templateId) {
    const { data } = await api.get(`/quote-templates/${templateId}/history`);
    return data.versions || [];
}

export async function restoreQuoteTemplateVersion(templateId, versionId) {
    const { data } = await api.post(
        `/quote-templates/${templateId}/restore/${versionId}`,
    );
    return data;
}

export async function deleteQuoteTemplateVersion(versionId) {
    const { data } = await api.delete(`/quote-templates/versions/${versionId}`);
    return data;
}

export async function uploadQuoteTemplateLogo(file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/quote-templates/logo", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

export async function uploadQuoteAttachment(file, onUploadProgress) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/quote-templates/attachment", fd, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
        // Big PDFs / hi-res images can take a moment over residential DSL
        timeout: 120000,
    });
    return data;
}

export async function fetchQuoteAttachmentData(storagePath) {
    const { data } = await api.get("/quote-templates/attachment-data", {
        params: { storage_path: storagePath },
        timeout: 60000,
    });
    return data; // { data_url, mime, size }
}

// ----- Quote shares (e-sign / accept flow) -----

export async function createQuoteShare(estimateId, snapshot) {
    const { data } = await api.post(`/quotes/${estimateId}/share`, { snapshot });
    return data;
}

export async function listQuoteShares(estimateId) {
    const { data } = await api.get(`/quotes/${estimateId}/shares`);
    return data;
}

export async function revokeQuoteShare(shareId) {
    const { data } = await api.delete(`/quote-shares/${shareId}`);
    return data;
}

export async function emailQuoteShare(shareId, payload) {
    const { data } = await api.post(`/quote-shares/${shareId}/email`, payload, {
        timeout: 30000,
    });
    return data;
}
// Public (no-auth) helpers — used by /q/{token}

export async function getPublicQuote(token) {
    const { data } = await api.get(`/public/quotes/${token}`);
    return data;
}

export async function acceptPublicQuote(token, payload) {
    const { data } = await api.post(`/public/quotes/${token}/accept`, payload);
    return data;
}

export async function getPublicQuoteAttachmentData(token, storagePath) {
    const { data } = await api.get(
        `/public/quotes/${token}/attachment-data`,
        { params: { storage_path: storagePath }, timeout: 60000 },
    );
    return data;
}

// ----- Client errors (error boundary → admin panel) -----
